import { style, styleVariants } from '@vanilla-extract/css';
import { TundrLogoVariant } from './TundrLogo.types';

export const logoClass = style({
  objectFit: 'cover',
});

export const logoWidthClass = styleVariants({
  [TundrLogoVariant.DARK]: {
    width: 55,
  },
  [TundrLogoVariant.LIGHT]: {
    width: '100%',
  },
  [TundrLogoVariant.SMALL]: {
    width: '100%',
  },
  [TundrLogoVariant.SMALL_DARK]: {
    width: 20,
  },
});
